<template>
    <div class="contenedor-barras-apiladas"
    :class="{'es-un-grupo':esUnGrupo}"
    >
        <div class="header-barras">
            <a class="titulo-proyecto" v-if="enlace_proyecto" :href="enlace_proyecto">
            {{titulo_proyecto}}
            </a>
            <p class="titulo-proyecto" v-if="!enlace_proyecto && titulo_proyecto">
                {{titulo_proyecto}}
            </p>
            <h3 class="titulo-visualizacion" v-if="titulo">{{titulo}}</h3>
            <p class="instruccional" v-if="instruccional">{{instruccional}}</p>
        </div>
        <div class="body-barras">
            <div class="contenedor-svg" ref="contenedor_svg"
            :class="svgClases"
            >
                <svg ref="svg" :width="width" :height="height">
                    <g ref="contenedor_barras"></g>
                </svg>
            </div>
            <div class="tooltip-barras-agrupadas" ref="tooltip">
                <div class="contenedor-boton-cerrar" :class="{'show':isTouchDevice}">
                    <span>{{titulo_tooltip}}</span>
                    <button class="boton-cerrar-tooltip" @click="cerrarTooltip()" >
                        <img src="@/assets/img/cerrar.svg" alt="Cerrar Tooltip">
                    </button>
                </div>
                <p class="tooltip-variable" ref="tooltip_variable"> </p>
                <p class="tooltip-cifra" ref="tooltip_cifra">120 | <b> 29.3%</b></p>
            </div>
        </div>
        <div class="footer-barras">
            <div class="leyenda-barras-apiladas">
                <p class="titulo-leyenda">{{titulo_leyenda}}</p>
                <div class="label-1" v-for="(variable,i) in variables" :key="variable.id">
                    <CheckboxColor :color="variable.color" v-model="lista_filtros_activos[i]" >
                    <span class="categoria-texto">{{variable.nombre}}</span>
                    </CheckboxColor>
                </div>
            </div>
            <PieComponenteLibreria/>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import * as d3 from 'd3';
import CheckboxColor from "./CheckboxColor.vue";
import PieComponenteLibreria from '@/components/base/PieComponenteLibreria.vue';

export default {
    components:{
        CheckboxColor,
        PieComponenteLibreria
    },
    props:{
        datos: {
            type: Array,
            default: () => [{nombre:'Nombre de variable 2 ', cantidad_1:120,cantidad_2:30}],
        },
        orientacion:{
            type: String,
            default:"horizontal"
        },
        nombre_variables:{
            type: Object,
            default:function(){
                return { 'nombre':'nombre' }
            }
        },
        variables: {
            type: Array,
            default:function(){
                return ['nombre','cantidad_1','cantidad_2']
            }
        },
        margen: {
            type: Object,
            default: function() {
                return {
                    arriba: 30,
                    abajo: 40,
                    izquierda: 60,
                    derecha: 20,
                }
            },
        },

        titulo: String,
        instruccional: String,
        titulo_leyenda: String,
        enlace_proyecto: String,
        titulo_proyecto: String,
        texto_fuente: String,
        texto_notas: String,
        link_descarga_csv: String,

        titulo_tooltip: {
            type: String,
            default: '',
        },
    },
    data:function(){
        return {
            d3Elements:{},
            svgSize:[200,200],
            width:100,
            height:100,
            width_sin_margen:0,
            height_sin_margen:100,
            cuantitativeScale:undefined,
            categoricalScale:undefined,
            escalaSub:undefined,
            data_apilada:undefined,
            lista_filtros_activos:[],
            filter_data:undefined,
            timer_scroll:0,
            scroll:false,
            isTouchDevice:false
        }
    },
    mounted: function(){
        this.isTouchDevice = isTouchDevice()
        this.lista_filtros_activos = this.variables.map(item=>true);

        this.d3Elements["svg"] = d3.select(this.$refs.svg)
        this.d3Elements["g_contenedor"] = d3.select(this.$refs.contenedor_barras)
        this.d3Elements["eje_x"] = this.d3Elements["g_contenedor"]
            .append('g')
            .attr('class', 'eje-x');
        this.d3Elements["eje_y"] = this.d3Elements["g_contenedor"]
            .append('g')
            .attr('class', 'eje-y');
        this.filterActiveData()
        this.configurandoDimensionesParaSVG()
        this.configurandoDimensionesParaBarras()
        this.creandoBarras()
        this.actualizandoBarras()

        window.addEventListener("resize",this.reescalandoPantalla)

        this.$refs.contenedor_svg.addEventListener("scroll",(e)=>{
            this.cerrarTooltip()
            this.scroll_value = this.orientacion ==="horizontal" ? e.target.scrollLeft : e.target.scrollTop
            clearTimeout( this.timer_scroll)
            this.timer_scroll = setTimeout(()=>{
                if( this.orientacion ==="horizontal" ){
                    this.d3Elements["eje_y"].transition()
                        .duration(200)
                        .attr('transform', `translate(${this.scroll_value},0)`);
                }else{
                    this.d3Elements["eje_x"].transition()
                        .duration(200)
                        .attr('transform', `translate(0,${this.scroll_value})`);
                }

            },300)

        })
    },
    methods: {
        filterActiveData:function(){

        },
        configurandoDimensionesParaSVG: function(){
            this.scroll = this.datos.length > 1;
            let long_in_scroll=getLongScrollData(9,this.variables.length,.02,this.datos.length,0.1)
            if(this.orientacion==="horizontal"){
                this.width = this.scroll ? long_in_scroll+this.margen.derecha + this.margen.izquierda : this.$refs.contenedor_svg.clientWidth;
                this.height = this.$refs.contenedor_svg.clientHeight;

            }else{
                this.width =  this.$refs.contenedor_svg.clientWidth;
                this.height = this.scroll ? long_in_scroll+this.margen.arriba + this.margen.abajo : this.$refs.contenedor_svg.clientHeight
            }
            this.width_sin_margen = this.width - this.margen.izquierda - this.margen.derecha
            this.height_sin_margen = this.height - this.margen.arriba - this.margen.abajo


            this.d3Elements["g_contenedor"]
                .attr('transform', `translate(${this.margen.izquierda},${this.margen.arriba})`);
        },
        configurandoDimensionesParaBarras:function(){
            const variables_activas=this.variables.filter((variable,idx)=>{
                return this.lista_filtros_activos[idx]
            })
            const datos_ordenados = sortDataByActiveVariables(this.datos, variables_activas)

            this.data_apilada = d3.stack()
            .keys(variables_activas.map((d) => d.id))(datos_ordenados);
            for (let i = variables_activas.length -1 ; i >= 0; i -= 1) {
                this.data_apilada[i].forEach((dd) => {
                    dd.data = Object.assign({ }, dd.data, { key: this.data_apilada[i].key });
                });

                let cuantitativeRange= this.orientacion==='horizontal'
                    ? [ this.height_sin_margen ,0]
                    : [0, this.width_sin_margen]
                this.cuantitativeScale = d3.scalePow().exponent(.5) //d3.scaleLinear()
                    .domain([0, d3.max(datos_ordenados.map((d) => d3.max(variables_activas.map((dd) => d[dd.id]))))])
                    .range(cuantitativeRange);
                this.categoricalScale = d3.scaleBand()
                    .domain(datos_ordenados.map((d) => d[this.nombre_variables.nombre]))
                    .range([0, (this.orientacion==="horizontal"?this.width_sin_margen:this.height_sin_margen)])
                    .padding(0.1);
                this.escalaSub = d3.scaleBand()
                    .domain(variables_activas.map((d) => d.id))
                    .range([0, this.categoricalScale.bandwidth()])
                    .padding(0.02);

                if(this.orientacion==="horizontal"){

                    //el eje y donde estan las cantidades
                    this.d3Elements["eje_y"].transition().duration(100).call(
                        d3.axisLeft(this.cuantitativeScale)
                        .ticks(4)
                    )

                    this.d3Elements["eje_y"].selectAll('line')
                        .attr('x1', this.width_sin_margen)
                        .style('stroke-dasharray', '3 2')
                        .style('stroke', '#707070');
                    this.d3Elements["eje_y"].select('path')
                        .style('opacity', 0);

                    //el eje x donde estan las categorias
                    this.d3Elements["eje_x"].call(d3.axisBottom(this.categoricalScale))
                        .attr('transform', `translate(0,${this.height_sin_margen})`);
                    this.d3Elements["eje_x"].select('path.domain')
                        .attr('d', function() { d3.select(this).attr('d').replace('M-6', 'M 0').replace('H-6', 'H0')});
                    this.d3Elements["eje_y"]
                        .attr('transform', `translate(0,0)`);
                }else{

                    this.d3Elements["eje_x"].transition().duration(100).call(
                        d3.axisTop(this.cuantitativeScale)
                        .ticks(4)
                    )
                    this.d3Elements["eje_x"].attr('transform', `translate(0,0)`);

                    this.d3Elements["eje_x"].selectAll('line')
                        .attr('y1', this.height_sin_margen)
                        .style('stroke-dasharray', '3 2')
                        .style('stroke', '#707070');
                    this.d3Elements["eje_x"].select('path')
                        .style('opacity', 0);

                    //El eje y donde estan las categorias
                    this.d3Elements["eje_y"].call(d3.axisLeft(this.categoricalScale))
                        .attr('transform', `translate(0,0)`);
                    this.d3Elements["eje_y"].select('path.domain')
                        .attr('d', function() { d3.select(this).attr('d').replace('M-6', 'M 0').replace('H-6', 'H0')});

                }


            }
            //console.log(this.data_apilada)
        },
        creandoBarras: function(){
            const variables_activas=this.variables.filter((variable,idx)=>{
                    return this.lista_filtros_activos[idx]
                })

                this.d3Elements["g_contenedor"].selectAll(".grupos-barras").remove()
                this.d3Elements["barras_apiladas"] = this.d3Elements["g_contenedor"]
                    .selectAll('grects')
                    .data(this.data_apilada)
                    .enter()
                    .append('g')
                    .attr('class', (d) => `${d.key} grupos-barras`)
                    .style('fill', (d, i) => variables_activas[i].color)
                    //.on('mouseover', (evento, datum) => this.mouseOverBarras(evento, datum))
                    //.on('mouseout', this.mouseOutBarras);
                this.d3Elements["barras_individuales"] = this.d3Elements["barras_apiladas"]
                    .selectAll('rect')
                    .data((d) => d)
                    .enter()
                    .append('rect')


        },
        actualizandoBarras:function(){
            this.d3Elements["barras_individuales"]
                .attr('y', (d) => this.orientacion==="horizontal"
                    ? this.cuantitativeScale(d[1] - d[0])
                    : this.categoricalScale(d.data[this.nombre_variables.nombre]) + this.escalaSub(d.data.key) )
                //.transition().duration(750)
                .attr('x', (d) =>  this.orientacion==="horizontal"
                    ? this.categoricalScale(d.data[this.nombre_variables.nombre]) + this.escalaSub(d.data.key)
                    : 0 )


                //.transition().duration(750)
            this.d3Elements["barras_individuales"]
                .attr('width', d => this.orientacion==="horizontal"
                    ? this.escalaSub.bandwidth()
                    : this.cuantitativeScale(d[1] - d[0]) )
                .attr('height',d => this.orientacion==="horizontal"
                    ? this.cuantitativeScale(0) - this.cuantitativeScale( d[1] - d[0])
                    : this.escalaSub.bandwidth() )

            this.d3Elements["barras_individuales"]
                .on("mouseover",(evento,datum)=>{
                    this.mostrarTooltip(evento,datum)
                })
                .on("mouseout",()=>{
                    if(window.innerWidth >= 769){
                        this.cerrarTooltip()
                    }                    
                })
                .on("mousemove",(evento,datum)=>{
                    this.moverTooltip(evento,datum)
                })

            
            if(this.isTouchDevice){
                this.d3Elements["barras_individuales"]
                    .on("click",(evento,datum)=>{
                        this.mostrarTooltip(evento,datum)
                    })
            }
            

                
                /*
                .on('click', (evento, datum) => {
                this.modo_tooltip="click"
                this.mostrarTooltip(evento, datum)
                })
                .on("mouseover",(evento, datum)=> {
                if(this.modo_tooltip!=="click"){
                    this.mostrarTooltip(evento, datum)
                }

                })
                .on("mouseout", ()=>{
                if(this.modo_tooltip=="hover"){
                    this.reestablecerVista()
                }
                })
                */

        },
        reescalandoPantalla: function(){
            this.reestablecerVista()
            this.configurandoDimensionesParaSVG()
            this.configurandoDimensionesParaBarras()
            this.creandoBarras()
            this.actualizandoBarras()
        },
        contenidoTooltip(datum) {
            const variable = this.variables.filter((d) => d.id === datum.data.key)[0]
            return ` <span class="indicador-color" style="background-color:${variable.color} "></span> ${
                variable.nombre
            }  | <b>${
                datum.data[variable.id].toLocaleString('en')
            }<b>`
        },
        mostrarTooltip (evento,datum){
            d3.select(this.$refs.tooltip)
                .style("visibility","visible")
                .style("left",`${evento.clientX+this.$refs.tooltip.clientWidth>this.$refs.contenedor_svg.clientWidth
                    ? evento.pageX-this.$refs.tooltip.clientWidth
                    : evento.pageX}px`)
                .style("top",`${evento.layerY+this.$refs.tooltip.clientHeight>this.$refs.contenedor_svg.clientHeight
                    ? evento.pageY-this.$refs.tooltip.clientHeight
                    : evento.pageY}px`)
            d3.select(this.$refs.tooltip_variable)
                .text(datum.data.estado)
            d3.select(this.$refs.tooltip_cifra)
                .html(this.contenidoTooltip(datum))
        },
        cerrarTooltip (){
            d3.select(this.$refs.tooltip)
                .style("visibility","hidden")
                .style("left",`0`)
                .style("top",`0`)
        },
        moverTooltip (evento,datum){
            d3.select(this.$refs.tooltip)
                .style("left",`${evento.clientX+this.$refs.tooltip.clientWidth>this.$refs.contenedor_svg.clientWidth
                    ? evento.pageX-this.$refs.tooltip.clientWidth
                    : evento.pageX}px`)
                .style("top",`${evento.layerY+this.$refs.tooltip.clientHeight>this.$refs.contenedor_svg.clientHeight
                    ? evento.pageY-this.$refs.tooltip.clientHeight
                    : evento.pageY}px`)
        },
        reestablecerVista (){
            clearTimeout( this.timer_scroll);
            //mover al top o left si hay scroll
            setTimeout(()=>{
                this.$refs.contenedor_svg.scrollTop= 0
                this.$refs.contenedor_svg.scrollLeft= 0
            },200)

        }
    },
    computed:{
        svgClases:function(){
            let clases= []
            if(this.orientacion=='horizontal' && this.scroll){
                clases.push('overflow-x')
            }else if(this.orientacion==='vertical' && this.scroll){
                clases.push('overflow-y')
            }
            return clases
        },
        esUnGrupo:function(){
            return this.datos.length == 1;
        }
    },
    watch:{
        lista_filtros_activos(lista) {
            this.reestablecerVista()
            this.configurandoDimensionesParaSVG()
            this.configurandoDimensionesParaBarras()
            this.creandoBarras()
            this.actualizandoBarras()

        },
        datos:function(nv, ov){
            setTimeout(()=>{
                this.reestablecerVista()
                //console.log("actualizando datos")
                this.configurandoDimensionesParaSVG()
                this.configurandoDimensionesParaBarras();
                this.creandoBarras()
                this.actualizandoBarras()
                },300)

        }
    }
}

const getLongScrollData=(ancho,variables,variables_padding,categorias,categorias_padding)=>{
    let long_categoria = (ancho * variables) + ((ancho * variables_padding)*(variables+1))
    let long_all = (long_categoria *categorias) +((long_categoria *categorias_padding)* (categorias+1))
    return long_all
}

const sortDataByActiveVariables = (datos,variables)=>{
  //console.log(variables)
  const sumarVariablesActivasDelGrupo=(dato1group,variables_activas_lista)=>{
    return Object.entries(dato1group)
      .filter(key_value=> variables_activas_lista.includes( key_value[0]))
      .reduce((suma_status,current_status)=>{
        suma_status = suma_status + current_status[1]
        return suma_status
      },0)
  }

  const variables_array= Object.values(variables).map(una_var=>una_var.id)
  //console.log(variables_array)
  return datos.sort((elementoComparaA,elementoComparaB)=>{
    const sumaElA = sumarVariablesActivasDelGrupo(elementoComparaA,variables_array);
    const sumaElB = sumarVariablesActivasDelGrupo(elementoComparaB, variables_array);

    return sumaElB - sumaElA
  })
}

const isTouchDevice = function() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}
</script>



<style lang="scss" scoped>
$border-radius-tarjeta: 10px;
.contenedor-svg{
    height: 400px;
    width: 100%;
    &.overflow-y{
        overflow-y: auto;
        overflow-x: hidden;
    }
    &.overflow-x{
        overflow-y: hidden;
        overflow-x: auto;
    }

}

div.contenedor-barras-apiladas {
    font-family: "Montserrat";
    width: 100%;
    // border: solid black 1px;
    // border-radius: $border-radius-tarjeta;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      &.es-un-grupo{
        display: grid;
        grid-template-areas: "header body"
                            "footer body";
        grid-template-columns: 300px 1fr;
        grid-template-rows: auto 1fr;
        .header-barras{
          grid-area: header;
          border-right: 1px solid black;
        }
        .body-barras{
          grid-area: body;
          overflow: hidden;
        }
        .footer-barras{
          grid-area: footer;
          border-right: 1px solid black;
          border-top: 1px solid black;
          div.leyenda-barras-apiladas{
            box-shadow: none;
            >div{
              width: 50%;
              flex: 0 0 50%;
            }
          }
        }
      }
    }

  }

  div.leyenda-barras-apiladas{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    border-radius: $border-radius-tarjeta;
    box-shadow: 0px -5px 5px -1px rgb(221, 221, 221);
    margin-bottom:10px;
    justify-content: center;
    p.titulo-leyenda{
      width: 100%;
      margin-bottom: 5px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
    }
    div{
      margin-top: 10px;
      width: 50%;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      @media (min-width: map-get($media-queries-limit, "mobile")) {
        width: 16%;
        -ms-flex: 0 0 16%;
        flex: 0 0 16%;
      }
      max-width: calc(50% - 20px);
      padding: 0px 10px;
      display: flex;
      span.categoria-color{
        width: 25px;
        height: 25px;
        min-width: 25px;
        display: inline-block;
        border-radius: 50%;
        position: relative;
      }
      span.categoria-texto{
        display: inline-block;
        position: relative;
        padding-left: 5px;
        font-size: 10px;
        top: 50%;
        transform: translateY(-50%);
        margin-bottom: auto;
      }
      &.active{
        color:#000;
      }
      &.inactive{
        color:gray;
        span.categoria-color{
          background:#dbdbdb!important;
        }
      }
    }
  }

.tooltip-barras-agrupadas{
    position: absolute;
    visibility: hidden;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 8px;
    width: 180px;
    // padding: 0px 3px 0px 10px;
    padding: 10px;
    color: #fff;
    font-size: 12px;
    min-height: 40px;
    line-height: 1;
    p{
        margin: 0;
    }
    button.boton-cerrar-tooltip {
        background: none;
        border: none;
        padding: 0 0 0 5px;
        cursor: pointer;
        max-width: none;
        img {
            width: 30px;
            max-width: none;
            height: 30px;
        }
        // @media (min-width: map-get($media-queries-limit, "mobile")) {
        // display: none;
        // }
    }
    div.contenedor-boton-cerrar {
        float: right;
        height: auto;
        width: 35px;
        // padding-top: 5px;
        justify-content: space-between;
        display: none;
        &.show {
            // En móvil el botón de cerrar desaparece
            display: block;
        }
    }
}
</style>


<style lang="scss">
.indicador-color{
    width: 1em;
    height: 1em;
    border: 1px solid white;
    border-radius: 50%;
    display: inline-block;
    margin-top: 5px;
    line-height: 1;
}
</style>